import axios from "axios";
import authHeader from "./auth_header";
import * as CONST from './common'

const API_URL = CONST.API_URL;

const getPublicContent = () => {
    return axios.get(API_URL + "all");
};

const getAdminBoard = () => {
    return axios.get(API_URL + "admin", { headers: authHeader() });
};

const getAppInfo = (app_id, type = '') => {
    if (type === '') {
        return axios.get(API_URL + 'apps/' + encodeURI(app_id), { headers: authHeader() });
    }
    else {
        return axios.get(API_URL + 'apps/' + encodeURI(app_id) + '?type=' + type, { headers: authHeader() });
    }
}

const getAppsList = (order = 'asc', page = '1', filter_name = '', user_id = null) => {
    return axios.get(API_URL + 'apps?order=' + order + '&page=' + page + '&user=' + user_id + '&filter=' + filter_name, { headers: authHeader() });
}

const getLastReviews = (app_id) => {
    return axios.get(API_URL + 'reviews?app_id=' + app_id + '&last=' + true, { headers: authHeader() });
}

const getReviews = (app_id, page = 1, rating = '', lang = '', country = '', version = '') => {
    return axios.get(API_URL + 'reviews?app_id=' + app_id + '&page=' + page + '&rating=' + rating + '&lang=' + lang + '&country=' + country + '&version=' + version, { headers: authHeader() });
}

const getAppVersions = (app_id, rating = '', country = '', appVersion = '') => {
    return axios.get(API_URL + 'app_versions?app_id=' + app_id + '&rating=' + rating + '&country=' + country, { headers: authHeader() });
}

const getAppCountries = (app_id, rating = '', country = '', appVersion = '') => {
    return axios.get(API_URL + 'app_countries?app_id=' + app_id + '&rating=' + rating + '&app_version=' + appVersion, { headers: authHeader() });
}

const getCountries = () => {
    return axios.get(API_URL + 'countries', { headers: authHeader() });
}

const getRatingDistribution = (app_id) => {
    return axios.get(API_URL + 'ratings?app_id=' + app_id, { headers: authHeader() });
}

const getAppSubscribers = (app_id) => {
    return axios.get(API_URL + 'subscribers?app_id=' + app_id, { headers: authHeader() });
}

const searchApp = (searchTerm, storeType, countryCode) => {
    return axios.post(API_URL + 'search', { query: searchTerm, store_type: storeType, country_code: countryCode }, { headers: authHeader() });
}

const addSource = (app_id, storeType, countryCode) => {
    return axios.post(API_URL + 'add_source', { app_id: app_id, store_type: storeType, country_code: countryCode }, { headers: authHeader() })
}

const removeSource = (app_id) => {
    return axios.post(API_URL + 'remove_source?app_id=' + app_id, {}, { headers: authHeader() });
}

const getAppRevenue = (app_id) => {
    return axios.get(API_URL + 'revenue?app_id=' + app_id, { headers: authHeader() });
}

const translate_review =(review_id) => {
    return axios.get(API_URL + 'translate_review?review_id=' + review_id, {headers: authHeader()});
}

export default {
    getPublicContent,
    getAdminBoard,
    getAppsList,
    getAppInfo,
    getLastReviews,
    getRatingDistribution,
    getAppSubscribers,
    getReviews,
    getAppVersions,
    getAppCountries,
    searchApp,
    getCountries,
    addSource,
    removeSource,
    getAppRevenue,
    translate_review
};